import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const formatDate = (ds) => {
  if (!ds) return "";
  try {
    const d = new Date(ds);
    if (isNaN(d.getTime())) return ds;
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return ds; }
};

const formatDateForFile = (ds) => {
  if (!ds) return new Date().toISOString().split("T")[0];
  try {
    const d = new Date(ds);
    return isNaN(d.getTime()) ? new Date().toISOString().split("T")[0] : d.toISOString().split("T")[0];
  } catch { return new Date().toISOString().split("T")[0]; }
};

const V = (v) => (v !== undefined && v !== null && v !== "" ? String(v) : "");
const NR = (v) => (v !== undefined && v !== null && v !== "" ? String(v) : "NR");

const normalise = (inp) => {
  const d = { ...inp };
  return {
    tcds_no: d.tcds_no || "",
    date: d.date || "",
    cr_date: d.cr_date || "",
    mark_dept: d.mark_dept || "AUTOMATION",
    customer: d.customer || "",
    project_name: d.project_name || "",
    purchase_order_no: d.po_no || d.purchase_order_no || "",
    offer_no: d.offer_no || "",
    po_received_on: d.po_received_on || "",
    tcds_released_on: d.tcds_released_on || "",
    valve_type: d.valve_type || "",
    valve_type_other: d.valve_type_other || "",
    design_type: d.design_type || "",
    design_type_other: d.design_type_other || "",
    series: d.series || "",
    series_other: d.series_other || "",
    section_no: d.section_no || "",
    valve_size: d.valve_size || "",
    qty: d.qty || "",
    qty_other: d.qty_other || "",
    valve_pressure_class: d.valve_pressure_class || "",
    valve_pressure_class_other: d.valve_pressure_class_other || "",
    painting_req: d.painting_req || "",
    painting_req_other: d.painting_req_other || "",
    asme_max_pre: d.asme_max_pre || "",
    asme_min_pre: d.asme_min_pre || "",
    asme_min_temp: d.asme_min_temp || "",
    asme_max_temp: d.asme_max_temp || "",
    cust_max_pre: d.cust_max_pre || "",
    cust_min_pre: d.cust_min_pre || "",
    cust_max_temp: d.cust_max_temp || "",
    cust_min_temp: d.cust_min_temp || "",
    cust_min_pre2: d.cust_min_pre2 || "",
    cust_max_temp2: d.cust_max_temp2 || "",
    cust_min_temp2: d.cust_min_temp2 || "",
    max_field_test_pressure: d.max_field_test_pressure || "",
    valve_function_duty: d.valve_function_duty || "",
    valve_function_other: d.valve_function_other || "",
    regulating_sub_type: d.regulating_sub_type || "",
    valve_orientation: d.valve_orientation || "",
    valve_orientation_other: d.valve_orientation_other || "",
    hing_pin: d.hing_pin || "",
    upstream_end_conn_type: d.upstream_end_conn_type || "",
    downstream_end_conn_type: d.downstream_end_conn_type || "",
    upstream_end_conn_std: d.upstream_end_conn_std || "",
    downstream_end_conn_std: d.downstream_end_conn_std || "",
    end_conn_others_up: d.end_conn_others_up || "",
    end_conn_others_dn: d.end_conn_others_dn || "",
    full_round_opening: d.full_round_opening || "",
    end_conn_full_round_others: d.end_conn_full_round_others || "",
    pipe_od_upstream: d.pipe_od_upstream || "",
    pipe_od_downstream: d.pipe_od_downstream || "",
    bw_pipe_id_upstream: d.bw_pipe_id_upstream || "",
    bw_pipe_id_downstream: d.bw_pipe_id_downstream || "",
    bw_pipe_moc_upstream: d.bw_pipe_moc_upstream || "",
    bw_pipe_moc_downstream: d.bw_pipe_moc_downstream || "",
    bw_pipe_thickness_upstream: d.bw_pipe_thickness_upstream || "",
    bw_pipe_thickness_downstream: d.bw_pipe_thickness_downstream || "",
    special_chemistry_upstream: d.special_chemistry_upstream || "",
    special_chemistry_downstream: d.special_chemistry_downstream || "",
    smys_upstream: d.smys_upstream || "",
    smys_downstream: d.smys_downstream || "",
    cladding_upstream: d.cladding_upstream || "",
    cladding_downstream: d.cladding_downstream || "",
    design_std: d.design_std || "",
    design_std_other: d.design_std_other || "",
    testing_std: d.testing_std || "",
    testing_std_other: d.testing_std_other || "",
    face_to_face: d.face_to_face || "",
    face_to_face_other: d.face_to_face_other || "",
    operation: d.operation || "",
    operation_other: d.operation_other || "",
    leakage_class: d.leakage_class || "",
    leakage_class_other: d.leakage_class_other || "",
    media: d.media || "",
    special_flow_req: d.special_flow_req || "",
    radiography: d.radiography || "",
    radiography_extent: d.radiography_extent || "",
    radiography_std: d.radiography_std || "",
    radiography_special: d.radiography_special || "",
    ut: d.ut || "",
    ut_extent: d.ut_extent || "",
    ut_std: d.ut_std || "",
    ut_special: d.ut_special || "",
    mpt: d.mpt || "",
    mpt_extent: d.mpt_extent || "",
    mpt_std: d.mpt_std || "",
    mpt_special: d.mpt_special || "",
    pt: d.pt || "",
    pt_extent: d.pt_extent || "",
    pt_std: d.pt_std || "",
    pt_special: d.pt_special || "",
    pmi: d.pmi || "",
    pmi_extent: d.pmi_extent || "",
    pmi_std: d.pmi_std || "",
    pmi_special: d.pmi_special || "",
    nde_other: d.nde_other || "",
    gad_required: d.gad_required || "",
    qap_required: d.qap_required || "",
    lifting_hook: d.lifting_hook || "",
    flow_direction: d.flow_direction || "",
    valve_pressure_class_mat: d.valve_pressure_class_mat || "",
    vpc_mat_other: d.vpc_mat_other || "",
    painting_req_mat: d.painting_req_mat || "",
    paint_mat_other: d.paint_mat_other || "",
    trim_no: d.trim_no || "",
    disc: d.disc || "",
    seat: d.seat || "",
    body_bonnet_bolting: d.body_bonnet_bolting || "",
    gasket: d.gasket || "",
    drain_plug: d.drain_plug || "",
    hing_pin_mat: d.hing_pin_mat || "",
    qsl_level: d.qsl_level || "",
    applicable_clauses: d.applicable_clauses || "",
    vent_connection: d.vent_connection || "",
    drain_connection: d.drain_connection || "",
    support_ribs: d.support_ribs || "",
    gasket_add: d.gasket_add || "",
    body_bonnet_joint: d.body_bonnet_joint || "",
    non_standard_f2f: d.non_standard_f2f || "",
    intermediate_pressures: d.intermediate_pressures || "",
    valve_bore: d.valve_bore || "",
    pressure_boundary: d.pressure_boundary || "",
    alternate_seat_test: d.alternate_seat_test || "",
    lifting_add: d.lifting_add || "",
    assembly_lubricant: d.assembly_lubricant || "",
    drain_connection2: d.drain_connection2 || "",
    welding_overlay: d.welding_overlay || "",
    companion_flanges: d.companion_flanges || "",
    end_connectors: d.end_connectors || "",
    flange_bolting: d.flange_bolting || "",
    special_req_accessories: d.special_req_accessories || "",
    sour_service: d.sour_service || "",
    sour_service_std: d.sour_service_std || "",
    nace_req: d.nace_req || "",
    nace_std: d.nace_std || "",
    h2s_mass: d.h2s_mass || "",
    chlorides_mass: d.chlorides_mass || "",
    hydrostatic_testing: d.hydrostatic_testing || "",
    hydrostatic_specify: d.hydrostatic_specify || "",
    low_pre_gas_seat: d.low_pre_gas_seat || "",
    low_pre_specify: d.low_pre_specify || "",
    high_pre_gas: d.high_pre_gas || "",
    high_pre_specify: d.high_pre_specify || "",
    high_pre_gas_seat: d.high_pre_gas_seat || "",
    high_pre_gas_seat_specify: d.high_pre_gas_seat_specify || "",
    extended_hydrostatic: d.extended_hydrostatic || "",
    extended_specify: d.extended_specify || "",
    igc_test: d.igc_test || "",
    igc_specify: d.igc_specify || "",
    any_other_test: d.any_other_test || "",
    any_other_specify: d.any_other_specify || "",
    ibr_cert: d.ibr_cert || "",
    ibr_other: d.ibr_other || "",
    api_monogram: d.api_monogram || "",
    api_other: d.api_other || "",
    inspection_by: d.inspection_by || "",
    tpi_name: d.tpi_name || "",
    mtc_as_per: d.mtc_as_per || "",
    mtc_other: d.mtc_other || "",
    other_certification: d.other_certification || "",
    legal_requirements: d.legal_requirements || "",
    servicing_req: d.servicing_req || "",
    name_plate_req: d.name_plate_req || "",
    ld_clause: d.ld_clause || "",
    ld_percentage: d.ld_percentage || "",
    contract_delivery_date: d.contract_delivery_date || "",
    packing: d.packing || "",
    transport_mode: d.transport_mode || "",
    transport_other: d.transport_other || "",
    freight_terms: d.freight_terms || "",
    freight_other: d.freight_other || "",
    tpi_charges: d.tpi_charges || "",
    tpi_other: d.tpi_other || "",
    payment_terms: d.payment_terms || "",
    payment_other: d.payment_other || "",
    design_available: d.design_available || "",
    wps_available: d.wps_available || "",
    capability_review: d.capability_review || "",
    insp_testing: d.insp_testing || "",
    machining_facility: d.machining_facility || "",
    qualified_personnel: d.qualified_personnel || "",
    approved_suppliers: d.approved_suppliers || "",
    pattern_available: d.pattern_available || "",
    modification_req: d.modification_req || "",
    iom: d.iom || "",
    chemical_composition: d.chemical_composition || [],
    ph: d.ph || "",
    other_drain_connectors: d.other_drain_connectors || "",
    amendments: d.amendments || [],
    reviewed_by: d.reviewed_by || "",
    approved_by: d.approved_by || "",
    dept_planning: d.dept_planning || "",
    dept_production: d.dept_production || "",
    dept_quality: d.dept_quality || "",
    dept_purchase: d.dept_purchase || "",
    dept_sales: d.dept_sales || "",
    dept_design: d.dept_design || "",
    decision_on_deviation: d.decision_on_deviation || "",
  };
};

export const generateAPI6DExcel = async (tcdsData) => {
  const data = normalise(tcdsData);
  const wb = new ExcelJS.Workbook();
  wb.creator = "TCDS Generator";
  wb.created = new Date();

  const GREY = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD2D2D2" } };
  const BD = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  const BF = (sz = 7) => ({ name: "Arial", size: sz, bold: true });
  const NF = (sz = 7) => ({ name: "Arial", size: sz, bold: false });
  const CA = () => ({ horizontal: "center", vertical: "middle", wrapText: true });
  const LA = () => ({ horizontal: "left", vertical: "middle", wrapText: true });
  const RH = 15;

  const cell = (ws, r, c1, c2, label, value, fs = 7, rh = RH, align = "L") => {
    const alignment = align === "C" ? CA() : LA();
    if (c1 < c2) ws.mergeCells(r, c1, r, c2);
    const cellRef = ws.getCell(r, c1);
    const lStr = label ? V(label) + " " : "";
    const vStr = V(value);
    if (lStr && vStr) {
      cellRef.value = { richText: [{ font: BF(fs), text: lStr }, { font: NF(fs), text: vStr }] };
    } else if (lStr) {
      cellRef.value = lStr.trim();
    } else {
      cellRef.value = vStr;
    }
    cellRef.font = lStr ? BF(fs) : NF(fs);
    cellRef.alignment = alignment;
    cellRef.border = BD;
    if (rh !== false) ws.getRow(r).height = rh;
  };

  const twoCol = (ws, r, l1, v1, l2, v2) => {
    cell(ws, r, 1, 10, l1, v1);
    cell(ws, r, 11, 20, l2, v2);
  };

  const secHdr = (ws, r, c1, c2, text, fs = 7) => {
    if (c1 < c2) ws.mergeCells(r, c1, r, c2);
    const cellRef = ws.getCell(r, c1);
    cellRef.value = text;
    cellRef.font = BF(fs);
    cellRef.alignment = CA();
    cellRef.fill = GREY;
    cellRef.border = BD;
    ws.getRow(r).height = RH;
  };

  const setupSheet = (ws) => {
    for (let c = 1; c <= 20; c++) ws.getColumn(c).width = 5.8;
    Object.assign(ws.pageSetup, {
      paperSize: 9, orientation: "portrait",
      fitToPage: true, fitToWidth: 1, fitToHeight: 0,
      margins: { left: 0.4, right: 0.4, top: 0.4, bottom: 0.4, header: 0.2, footer: 0.2 },
    });
  };

  const drawPageHeader = (ws, pageNum, totalPages = 3) => {
    let R = 1;
    ws.mergeCells(R, 1, R, 20);
    const c1 = ws.getCell(R, 1);
    c1.value = "Contract Review Sheet (API 6D Swing Check Valve)";
    c1.font = BF(11);
    c1.alignment = CA();
    c1.border = BD;
    ws.getRow(R).height = 22;
    R++;

    ws.mergeCells(R, 1, R, 13);
    ws.mergeCells(R, 14, R, 20);
    const c2 = ws.getCell(R, 14);
    c2.value = `Format No. - F/MKT/18  Rev. 01  Dtd. 22/03/2024          ${pageNum} of ${totalPages}`;
    c2.font = NF(6);
    c2.alignment = { horizontal: "right", vertical: "middle" };
    ws.getRow(R).height = 11;
    R++;
    return R;
  };

  const ws1 = wb.addWorksheet("Page 1");
  setupSheet(ws1);
  let R = drawPageHeader(ws1, 1);

  cell(ws1, R, 1, 9, "Customer", data.customer);
  cell(ws1, R, 10, 15, "TCDS No.", data.tcds_no);
  cell(ws1, R, 16, 20, "Date", formatDate(data.date));
  R++;

  cell(ws1, R, 1, 5, "Mark Dept.", data.mark_dept);
  cell(ws1, R, 6, 15, "", "Contract Review Sheet (API 6D Swing Check Valve)");
  cell(ws1, R, 16, 20, "CR Date", formatDate(data.cr_date));
  R++;

  cell(ws1, R, 1, 6, "P. O. No", data.purchase_order_no);
  cell(ws1, R, 7, 12, "Offer No -", data.offer_no);
  cell(ws1, R, 13, 20, "Project Name", data.project_name);
  R++;

  twoCol(ws1, R, "P.O. RECEIVED ON", formatDate(data.po_received_on), "TCDS RELEASED ON", formatDate(data.tcds_released_on));
  R++;

  secHdr(ws1, R, 1, 20, "General & Necessary Requirements (Requirements Specified by Customer / Assumptions)");
  R++;

  twoCol(ws1, R, "Valve Type", data.valve_type, "Others", data.valve_type_other);
  R++;
  twoCol(ws1, R, "Design type", data.design_type, "Others", data.design_type_other);
  R++;
  twoCol(ws1, R, "Series", data.series, "Others", data.series_other);
  R++;

  cell(ws1, R, 1, 4, "Section No.", data.section_no);
  cell(ws1, R, 5, 10, "Valve size (NPS)", data.valve_size);
  cell(ws1, R, 11, 15, "Qty.- (Nos.)", data.qty);
  cell(ws1, R, 16, 20, "(if Other Specify)", data.qty_other);
  R++;

  cell(ws1, R, 1, 6, "Valve pressure class", data.valve_pressure_class);
  cell(ws1, R, 7, 10, "Others", data.valve_pressure_class_other);
  cell(ws1, R, 11, 17, "Painting Requirement", data.painting_req);
  cell(ws1, R, 18, 20, "Others -", data.painting_req_other);
  R++;

  secHdr(ws1, R, 1, 20, "Operating Conditions (As per ASME B 16.34)");
  R++;

  cell(ws1, R, 1, 5, "Max. Pre.", NR(data.asme_max_pre));
  cell(ws1, R, 6, 10, "Min. Pre.", NR(data.asme_min_pre));
  cell(ws1, R, 11, 15, "Min. Temp.", NR(data.asme_min_temp));
  cell(ws1, R, 16, 20, "Max. Temp.", NR(data.asme_max_temp));
  R++;

  cell(ws1, R, 1, 5, "Unit", "Kg/cm²", NF(7), RH, "C");
  cell(ws1, R, 6, 10, "Unit", "Kg/cm²", NF(7), RH, "C");
  cell(ws1, R, 11, 15, "Unit", "°C", NF(7), RH, "C");
  cell(ws1, R, 16, 20, "Unit", "°C", NF(7), RH, "C");
  R++;

  secHdr(ws1, R, 1, 20, "Operating Conditions (specified by customer)");
  R++;

  cell(ws1, R, 1, 5, "Max. Pre.", NR(data.cust_max_pre));
  cell(ws1, R, 6, 10, "Min. Pre.", NR(data.cust_min_pre));
  cell(ws1, R, 11, 15, "Max. Temp.", NR(data.cust_max_temp));
  cell(ws1, R, 16, 20, "Min. Temp.", NR(data.cust_min_temp));
  R++;

  cell(ws1, R, 1, 5, "Unit", "Kg/cm²", NF(7), RH, "C");
  cell(ws1, R, 6, 10, "Unit", "Kg/cm²", NF(7), RH, "C");
  cell(ws1, R, 11, 15, "Unit", "°C", NF(7), RH, "C");
  cell(ws1, R, 16, 20, "Unit", "°C", NF(7), RH, "C");
  R++;

  cell(ws1, R, 1, 5, "Min. Pre.", NR(data.cust_min_pre2));
  cell(ws1, R, 6, 10, "Max. Temp.", NR(data.cust_max_temp2));
  cell(ws1, R, 11, 15, "Min. Temp.", NR(data.cust_min_temp2));
  R++;

  cell(ws1, R, 1, 13, "Max. field test pressure", data.max_field_test_pressure ? data.max_field_test_pressure + " Kg/cm²" : "");
  R++;

  secHdr(ws1, R, 1, 14, "Operating Conditions and Valve Orientation");
  R++;

  twoCol(ws1, R, "Valve function (Duty)", data.valve_function_duty, "Others -", data.valve_function_other);
  R++;
  cell(ws1, R, 1, 11, "(if Regulating) specify Sub-Type -", data.regulating_sub_type);
  R++;
  cell(ws1, R, 1, 7, "Valve Orientation", data.valve_orientation);
  cell(ws1, R, 8, 13, "Others -", data.valve_orientation_other);
  cell(ws1, R, 14, 20, "Hing Pin", data.hing_pin);
  R++;

  secHdr(ws1, R, 1, 20, "Valve End Connection details");
  R++;

  cell(ws1, R, 1, 8, "", "Upstream", BF(7), RH, "C");
  cell(ws1, R, 9, 20, "", "Down-Stream", BF(7), RH, "C");
  R++;

  cell(ws1, R, 1, 8, "End Conn. Type", NR(data.upstream_end_conn_type));
  cell(ws1, R, 9, 20, "", NR(data.downstream_end_conn_type));
  R++;
  cell(ws1, R, 1, 8, "End Conn std.", NR(data.upstream_end_conn_std));
  cell(ws1, R, 9, 20, "", NR(data.downstream_end_conn_std));
  R++;
  cell(ws1, R, 1, 8, "Others (Specify)", NR(data.end_conn_others_up));
  cell(ws1, R, 9, 20, "", NR(data.end_conn_others_dn));
  R++;

  twoCol(ws1, R, "Full Round opening required", data.full_round_opening, "Others", data.end_conn_full_round_others);
  R++;

  secHdr(ws1, R, 1, 20, "For B/W End, Specify the following Data");
  R++;

  const bwLabels = [
    ["Pipe – OD.", "pipe_od_upstream", "pipe_od_downstream"],
    ["B/W Pipe – ID. -", "bw_pipe_id_upstream", "bw_pipe_id_downstream"],
    ["B/W Pipe MOC. -", "bw_pipe_moc_upstream", "bw_pipe_moc_downstream"],
    ["B/W Pipe thickness. -", "bw_pipe_thickness_upstream", "bw_pipe_thickness_downstream"],
    ["Special Chemistry of Pipe Material -", "special_chemistry_upstream", "special_chemistry_downstream"],
    ["Specified Min. Yield Strength (SMYS) -", "smys_upstream", "smys_downstream"],
    ["Cladding Requirement -", "cladding_upstream", "cladding_downstream"],
  ];

  bwLabels.forEach(([label, upKey, dnKey]) => {
    cell(ws1, R, 1, 8, label, NR(data[upKey]));
    cell(ws1, R, 9, 20, "", NR(data[dnKey]));
    R++;
  });

  twoCol(ws1, R, "Design Std.", data.design_std, "Others", data.design_std_other);
  R++;
  twoCol(ws1, R, "Testing Std.", data.testing_std, "Others", data.testing_std_other);
  R++;
  twoCol(ws1, R, "Face to Face", data.face_to_face, "Others", data.face_to_face_other);
  R++;
  twoCol(ws1, R, "Operation", data.operation, "Others", data.operation_other);
  R++;
  twoCol(ws1, R, "Leakage Class", data.leakage_class, "Others", data.leakage_class_other);
  R++;
  twoCol(ws1, R, "Media", data.media, "Any Special Flow Requirement", data.special_flow_req);
  R++;

  secHdr(ws1, R, 1, 20, "NDE Requirements");
  R++;

  const ndeLabels = [
    ["Radiography", "radiography", "radiography_extent", "radiography_std", "radiography_special"],
    ["Ultrasonic Testing", "ut", "ut_extent", "ut_std", "ut_special"],
    ["Magnetic Particle Test", "mpt", "mpt_extent", "mpt_std", "mpt_special"],
    ["Penetrant Test", "pt", "pt_extent", "pt_std", "pt_special"],
    ["PMI", "pmi", "pmi_extent", "pmi_std", "pmi_special"],
  ];

  ndeLabels.forEach(([name, key, extKey, stdKey, specKey]) => {
    cell(ws1, R, 1, 4, name, NR(data[key]));
    cell(ws1, R, 5, 8, "If Req. Specify Extent (%)-", NR(data[extKey]), 6);
    cell(ws1, R, 9, 16, "Standards", NR(data[stdKey]), 6);
    cell(ws1, R, 17, 20, "Any Special Requirement", NR(data[specKey]), 6);
    R++;
  });

  cell(ws1, R, 1, 8, "Any Other Req. in NDE", "");
  cell(ws1, R, 9, 20, "Specify", NR(data.nde_other));
  R++;

  secHdr(ws1, R, 1, 20, "Material of Construction and Trim Details");
  R++;

  cell(ws1, R, 1, 4, "GAD Required", NR(data.gad_required));
  cell(ws1, R, 5, 8, "QAP Required", NR(data.qap_required));
  cell(ws1, R, 9, 14, "Lifting Hook /Point", NR(data.lifting_hook));
  cell(ws1, R, 15, 20, "Flow Direction", NR(data.flow_direction));
  R++;

  cell(ws1, R, 1, 6, "Valve pressure class", NR(data.valve_pressure_class_mat));
  cell(ws1, R, 7, 10, "Others", NR(data.vpc_mat_other));
  cell(ws1, R, 11, 17, "Painting Requirement", NR(data.painting_req_mat));
  cell(ws1, R, 18, 20, "Others -", NR(data.paint_mat_other));
  R++;

  twoCol(ws1, R, "Trim No.", data.trim_no, "Disc", data.disc);
  R++;
  twoCol(ws1, R, "Seat", data.seat, "Body / Bonnet / Cover Bolting", data.body_bonnet_bolting);
  R++;
  twoCol(ws1, R, "Gasket (if required Specify MOC)", data.gasket, "Drain Plug", data.drain_plug);
  R++;

  cell(ws1, R, 1, 10, "Hing Pin", NR(data.hing_pin_mat));
  R++;

  twoCol(ws1, R, "QSL Level Required", data.qsl_level, "Applicable Clauses of API 6D", data.applicable_clauses);
  R++;

  const ws2 = wb.addWorksheet("Page 2");
  setupSheet(ws2);
  R = drawPageHeader(ws2, 2);

  secHdr(ws2, R, 1, 20, "Additional Requirements (API 6D)");
  R++;

  const addReq1 = [
    ["Vent Connection", "vent_connection", "Drain Connection", "drain_connection"],
    ["Support Ribs / Lug", "support_ribs", "Gasket", "gasket_add"],
    ["Body Bonnet Joint facing & Gasket", "body_bonnet_joint", "Non-standard Face-to face and End-to-end Dimensions", "non_standard_f2f"],
    ["Intermediate Pressures and Temperature Ratings", "intermediate_pressures", "Valve Bore", "valve_bore"],
    ["If Req. Specify Pressure Boundary Bolting—Hardness Testing", "pressure_boundary", "Alternate Seat Test", "alternate_seat_test"],
    ["Lifting", "lifting_add", "Use of Assembly Lubricant", "assembly_lubricant"],
    ["Drain Connection", "drain_connection2", "Welding Overlay Iron Dilution", "welding_overlay"],
  ];

  addReq1.forEach(([l1, k1, l2, k2]) => {
    twoCol(ws2, R, l1, NR(data[k1]), l2, NR(data[k2]));
    R++;
  });

  const addReq2 = [
    ["Companion Flanges", "companion_flanges"],
    ["End Connectors", "end_connectors"],
    ["Flange Bolting for Studded-outlet End Connectors", "flange_bolting"],
    ["Special Requirements (Accessories)", "special_req_accessories"],
  ];

  addReq2.forEach(([lbl, key]) => {
    cell(ws2, R, 1, 20, lbl, NR(data[key]));
    R++;
  });

  secHdr(ws2, R, 1, 20, "NACE/AMPP Requirements");
  R++;

  twoCol(ws2, R, "Sour Service", data.sour_service + (data.sour_service_std ? "  If Req. Specify Std. " + data.sour_service_std : ""), "NACE/AMPP Requirements", data.nace_req + (data.nace_std ? "  If Req. Specify Std. " + data.nace_std : ""));
  R++;

  cell(ws2, R, 1, 9, "If Required Specify % mass of H₂S", NR(data.h2s_mass));
  cell(ws2, R, 10, 20, "% mass of chlorides", NR(data.chlorides_mass));
  R++;

  secHdr(ws2, R, 1, 20, "Additional Testing Requirements (Specified by Customer)");
  R++;

  const testReq = [
    ["Hydrostatic Testing", "hydrostatic_testing", "hydrostatic_specify"],
    ["Low Pre. Gas Seat Test", "low_pre_gas_seat", "low_pre_specify"],
    ["High Pre. Gas Test", "high_pre_gas", "high_pre_specify"],
    ["High Pre. Gas Seat Test", "high_pre_gas_seat", "high_pre_gas_seat_specify"],
    ["Extended hydrostatic shell testing duration", "extended_hydrostatic", "extended_specify"],
    ["IGC Test", "igc_test", "igc_specify"],
    ["Any Other", "any_other_test", "any_other_specify"],
  ];

  testReq.forEach(([label, reqKey, specKey]) => {
    const reqVal = NR(data[reqKey]);
    cell(ws2, R, 1, 8, label, reqVal ? "If Yes Specify" : "");
    cell(ws2, R, 9, 20, "Specify", NR(data[specKey]));
    R++;
  });

  secHdr(ws2, R, 1, 20, "Inspection and Certification Requirements");
  R++;

  twoCol(ws2, R, "IBR Certification", data.ibr_cert, "Others", data.ibr_other);
  R++;
  twoCol(ws2, R, "API Monogram", data.api_monogram, "Others", data.api_other);
  R++;
  twoCol(ws2, R, "Inspection By", data.inspection_by, "If TPI, Specify Name", data.tpi_name);
  R++;
  twoCol(ws2, R, "MTC As per", data.mtc_as_per, "Others -", data.mtc_other);
  R++;
  cell(ws2, R, 1, 20, "Other Certification", NR(data.other_certification));
  R++;

  secHdr(ws2, R, 1, 20, "Supplementary Documentation Requirement");
  R++;
  cell(ws2, R, 1, 20, "Legal & Other Applicable Requirements -", NR(data.legal_requirements), 7, 25);
  R += 2;

  secHdr(ws2, R, 1, 20, "Servicing / After Sales Servicing Requirement");
  R++;
  cell(ws2, R, 1, 20, "Not Required", NR(data.servicing_req));
  R++;

  cell(ws2, R, 1, 20, "Name Plate / Tag Plate Requirement ( If any Special)", NR(data.name_plate_req));
  R++;
  twoCol(ws2, R, "LD Clause", data.ld_clause, "If applicable Specify %", data.ld_percentage);
  R++;

  secHdr(ws2, R, 1, 20, "Commercial Terms");
  R++;

  const commTerms = [
    ["Contract Delivery Date", data.contract_delivery_date, "Packing", data.packing],
    ["Transportation Mode", data.transport_mode, "Others", data.transport_other],
    ["Freight Terms", data.freight_terms, "Others", data.freight_other],
    ["TPI Charges", data.tpi_charges, "Others", data.tpi_other],
    ["Payment Terms", data.payment_terms, "Others", data.payment_other],
  ];

  commTerms.forEach(([l1, v1, l2, v2]) => {
    twoCol(ws2, R, l1, v1, l2, v2);
    R++;
  });

  secHdr(ws2, R, 1, 20, "Capability Review -");
  R++;

  const capReview = [
    ["Design Available -", data.design_available, "WPS available -", data.wps_available],
    ["Capability Review -", data.capability_review, "Insp & Testing Facility -", data.insp_testing],
    ["Machining Facility -", data.machining_facility, "Qualified Personnel -", data.qualified_personnel],
    ["Approved Suppliers -", data.approved_suppliers, "Pattern Available -", data.pattern_available],
    ["Is any Modification required in Pattern ?", data.modification_req, "IOM (Instruct and Operation Manual)", data.iom],
  ];

  capReview.forEach(([l1, v1, l2, v2]) => {
    twoCol(ws2, R, l1, v1, l2, v2);
    R++;
  });

  secHdr(ws2, R, 1, 20, "Chemical Composition");
  R++;

  const compositions = data.chemical_composition || [];
  for (let r = 0; r < 3; r++) {
    cell(ws2, R, 1, 2, String(r + 1), NR(compositions[r]), 7, RH, "C");
    cell(ws2, R, 3, 10, "", NR(compositions[r]), 7, RH, "L");
    cell(ws2, R, 11, 12, String(r + 4), NR(compositions[r + 3]), 7, RH, "C");
    cell(ws2, R, 13, 20, "", NR(compositions[r + 3]), 7, RH, "L");
    R++;
  }
  for (let r = 3; r < 5; r++) {
    cell(ws2, R, 1, 2, String(r + 1), NR(compositions[r]), 7, RH, "C");
    cell(ws2, R, 3, 10, "", NR(compositions[r]), 7, RH, "L");
    R++;
  }

  twoCol(ws2, R, "pH", data.ph, "Other Drain Connectors", data.other_drain_connectors);
  R++;

  const ws3 = wb.addWorksheet("Page 3");
  setupSheet(ws3);
  R = drawPageHeader(ws3, 3);

  secHdr(ws3, R, 1, 20, "AMENDMENT DESCRIPTION");
  R++;

  const amHeaders = ["Sr No", "Description of amendments sought", "Date", "Review Particulars", "Date", "Remark"];
  const amColSpans = [[1, 2], [3, 8], [9, 10], [11, 16], [17, 18], [19, 20]];
  amHeaders.forEach((h, i) => {
    const [c1, c2] = amColSpans[i];
    cell(ws3, R, c1, c2, h, "", 6, RH, "C");
  });
  R++;

  const amendments = data.amendments || [];
  for (let i = 0; i < 5; i++) {
    const am = amendments[i] || {};
    const vals = [
      String(i + 1),
      NR(am.description),
      formatDate(am.date),
      NR(am.review_particulars),
      formatDate(am.review_date),
      NR(am.remark),
    ];
    vals.forEach((val, j) => {
      const [c1, c2] = amColSpans[j];
      cell(ws3, R, c1, c2, "", val, 6, 27, "L");
    });
    R++;
  }
  R++;

  twoCol(ws3, R, "Reviewed By", data.reviewed_by, "Approved By", data.approved_by);
  R += 2;

  secHdr(ws3, R, 1, 20, "Reviewed / Participate By :");
  R++;

  const depts = ["Planning", "Production", "Quality", "Purchase", "Sales", "Design"];
  const deptSpans = [[1, 3], [4, 6], [7, 9], [10, 12], [13, 15], [16, 20]];
  depts.forEach((dept, i) => {
    const [c1, c2] = deptSpans[i];
    cell(ws3, R, c1, c2, dept, NR(data["dept_" + dept.toLowerCase()]), 7, 37, "C");
  });
  R += 3;

  cell(ws3, R, 1, 20, "Decision on deviation if any", NR(data.decision_on_deviation));
  R += 2;

  cell(ws3, R, 1, 2, "1.", "");
  cell(ws3, R, 3, 20, "", "The Contract Review Was Carried out by Cross Functional team and concluded that the Organization is capable to meet the requirements subject to above remarks and deviations if any after successful resolution with Customer..", 6, 30, "L");
  R += 3;

  cell(ws3, R, 1, 2, "2.", "");
  cell(ws3, R, 3, 20, "", "The Previously identified differing requirements if any have been resolved. The MOM duly signed is enclosed.", 6, 15, "L");
  R++;

  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const fileName = `TCDS_API6D_${V(data.tcds_no) || "Certificate"}_${formatDateForFile(data.date || data.tcds_released_on)}.xlsx`;
  saveAs(blob, fileName);
  return fileName;
};

export default generateAPI6DExcel;
